export function normalizeUsPhoneDigits(value?: string | null) {
  const rawDigits = String(value ?? "").replace(/\D/g, "");
  const digits = rawDigits.length === 11 && rawDigits.startsWith("1") ? rawDigits.slice(1) : rawDigits;
  return digits.slice(0, 10);
}

export function formatUsPhoneDisplay(value?: string | null) {
  const digits = normalizeUsPhoneDigits(value);
  if (!digits) return "";

  if (digits.length <= 3) {
    return `(${digits}`;
  }

  if (digits.length <= 6) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  }

  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}
